import { Button, InputField } from '@salt/components';
import React, { useCallback, useState } from 'react';
import { resetPassword } from '../../api/users';

const ResetPasswordModal = ({ handleResetPasswordModalClose }) => {
  const [email, setEmail] = useState('');

  const onDelete = useCallback(() => {
    resetPassword({ email }).catch(() => {
      console.error('Failed to reset password');
    });
    handleResetPasswordModalClose();
  }, [email]);

  return (
    <div id="dialog" className="overlay z-[100] fixed top-0 left-0 m-auto w-full h-full flex">
      <button
        type="button"
        className="fixed w-full h-full z-[99] bg-black/30"
        onClick={handleResetPasswordModalClose}
      />
      <div className="z-[100] w-[583px] react-modal small bg-secondary-light px-8 py-7 bg-white m-auto rounded-lg">
        <div className="text-lg mb-4 text-center">Reset Password</div>
        <span className="text-base">
          Please provide your email address to receive reset instructions.
        </span>
        <div className="mt-4">
          <InputField
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="Email"
            type="email"
            labelBackgroundClass="peer-focus:bg-secondary-light peer-[:not(:placeholder-shown)]:bg-secondary-light"
          />
        </div>

        <div className="mt-4">
          <br />
          <Button
            onClick={handleResetPasswordModalClose}
            type="neutral"
            className="max-w-[146px] h-[36px] ml-auto"
            paddingClassName="px-6"
          >
            Cancel
          </Button>
          <Button
            onClick={onDelete}
            type="positive"
            disabled={email.trim().length === 0}
            className="max-w-[146px] h-[36px] ml-auto float-right"
            paddingClassName="px-6"
          >
            Reset
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordModal;
